import { getByCode } from 'Config/lang';

const FANATICAL_HOSTS = ['www.fanatical.com', 'fanatical.com'];

/**
 * Converts an advert url into an in-app route, if it points at Fanatical.
 * Accepts absolute urls (https://www.fanatical.com/en/deals, https://www.fanatical.com/deals)
 * and relative ones (/deals, /en/deals). Any locale segment is removed, as the router adds it.
 * @param {string} url
 * @returns {string|null} route such as '/deals?sort=price', or null for an empty, off-site or invalid url
 */
const getAdvertRoute = (url) => {
  if (!url) return null;

  let parsed;
  try {
    // The base only applies to relative urls; an absolute url keeps its own host
    parsed = new URL(url, 'https://www.fanatical.com');
  } catch (e) {
    return null;
  }

  if (!FANATICAL_HOSTS.includes(parsed.hostname)) return null;

  const [, firstSegment, ...rest] = parsed.pathname.split('/');
  const pathname = getByCode(firstSegment) ? `/${rest.join('/')}` : parsed.pathname;

  return `${pathname}${parsed.search}${parsed.hash}`;
};

export default getAdvertRoute;
